import { assertExists } from '@blocksuite/global/utils';
import { INLINE_ROOT_ATTR } from '../consts.js';
export function findDocumentOrShadowRoot(editor) {
    const el = editor.rootElement;
    if (!el) {
        throw new Error('editor root element not found');
    }
    const root = el.getRootNode();
    if ((root instanceof Document || root instanceof ShadowRoot) &&
        'getSelection' in root) {
        return root;
    }
    return el.ownerDocument;
}
export function getInlineEditorInsideRoot(element) {
    const rootElement = element.closest(`[${INLINE_ROOT_ATTR}]`);
    assertExists(rootElement, 'element must be inside a v-root');
    const inlineEditor = rootElement.inlineEditor;
    assertExists(inlineEditor, 'element must be inside a v-root with inline-editor');
    return inlineEditor;
}
//# sourceMappingURL=query.js.map